// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"93de3b08","448":"e96d4369"}[chunkId] + ".chunk.js";
};